import React, { useCallback, useEffect } from 'react'
import { Spin } from 'antd'

import { showErrorNotification } from '../../../core/helpers'

import { APP_ROUTES } from '../../../common/constants'
import { useDocumentTitle } from '../../../common/hooks'

import { useLoggedInUser, useUpdateUserSettingsMutation } from '../../hooks'
import { UserSettingsForm } from '../forms'

const UserSettingsPage = () => {
  useDocumentTitle(APP_ROUTES.ACCOUNT.children.SETTINGS.label)
  const { id, settings } = useLoggedInUser()

  const [updateUserSettings, { isLoading, error }] =
    useUpdateUserSettingsMutation()

  const handleSave = useCallback(
    formValues =>
      updateUserSettings({
        userId: id,
        settings: formValues,
      }),
    [id, updateUserSettings],
  )

  useEffect(() => {
    if (error) {
      showErrorNotification({ title: 'Update settings', description: error })
    }
  }, [error])

  return isLoading ? (
    <Spin />
  ) : (
    <UserSettingsForm onSubmit={handleSave} settings={settings} />
  )
}

export default UserSettingsPage
